import { useQuery } from '@tanstack/react-query';
import { fetchMyPendingCorrectionsForAttendance } from '../api/myCorrectionsApi';
import { correctionKeys } from './correctionKeys';

export function usePendingCorrectionsForAttendance(attendanceId: string, enabled = true) {
  return useQuery({
    queryKey: correctionKeys.myPendingForAttendance(attendanceId),
    queryFn: () => fetchMyPendingCorrectionsForAttendance(attendanceId),
    enabled: enabled && attendanceId !== '',
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
